export default "__VITE_ASSET__9696323b__"